export const delivered = 'delivered';
export const resent = 'resent';
export const resentEmail = 'The following action email was resent';
export const notificationsMuted = 'notifications were muted (not delivered)';
